import React, { useEffect, useState } from "react";
import styles from "./notification.module.css";
import { post } from "../../../components/api";
import moment from "moment";

const Notification = () => {
  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await post("company/ltms/GetAllNotification", {});
      if (response.status == 200) {
        setData(response.data);
      }
    } catch (error) {
      alert(error.message || "error");
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  
  return (
    <div className={styles.Notification}>
      <div className={styles.Heading}>
        <p>Notification</p>
      </div>
      <div className={styles.MainDiv}>
        {data.map((d, i) => {
          return (
            <div className={styles.card} key={i}>
              <div>
                <svg
                  width="40"
                  height="38"
                  viewBox="0 0 60 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="60" height="58" rx="6" fill="#4C7889" />
                  <path
                    d="M37.7533 24.5013C37.7533 22.5119 36.963 20.6039 35.5562 19.1971C34.1495 17.7903 32.2415 17 30.252 17C28.2625 17 26.3545 17.7903 24.9478 19.1971C23.541 20.6039 22.7507 22.5119 22.7507 24.5013C22.7507 33.2529 19 35.7533 19 35.7533H41.504C41.504 35.7533 37.7533 33.2529 37.7533 24.5013Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M32.4151 40.7543C32.1953 41.1332 31.8798 41.4477 31.5002 41.6663C31.1207 41.885 30.6903 42.0001 30.2522 42.0001C29.8142 42.0001 29.3838 41.885 29.0042 41.6663C28.6246 41.4477 28.3092 41.1332 28.0894 40.7543"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div style={{ width: "100%" }}>
                <div className={styles.firstDiv}>
                  <p>{d.title}</p>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8.5"
                      cy="8.5"
                      r="8.5"
                      fill="#0078D7"
                      fillOpacity="0.1"
                    />
                    <circle
                      cx="8.5"
                      cy="8.5"
                      r="6.5"
                      fill="#0078D7"
                      fillOpacity="0.2"
                    />
                    <circle cx="8.4" cy="8.4" r="4.4" fill="#0078D7" />
                  </svg>
                </div>
                <div className={styles.secondDiv}>
                  <p>{d.message}</p>
                  <p>
                    {moment(d.createdAt)
                      .add(5, "hours")
                      .add(30, "minutes")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Notification;
